import React from 'react'

import { cn } from '@/shared/lib/utils'

export function BasicChoiceField({
	value,
	choices,
	className,
	...props
}: {
	value: any
	choices?: Record<string, any>
	className?: string
}) {
	if (!value) {
		return (
			<div className={cn('flex items-center gap-1', className)} {...props}>
				-
			</div>
		)
	}
	const items = getChoice(value, choices || [])

	return (
		<div className={cn('flex items-center gap-1', className)} {...props}>
			{items?.length > 0
				? items?.map((choice) => (
						<span key={String(value)}>
							{choice.icon}
							{choice.label}
						</span>
					))
				: '-'}
		</div>
	)
}

function getValueAsArray(value?: any) {
	return Array.isArray(value) ? value : value !== undefined ? [value] : []
}

export function getChoice<T>(value?: any, choices?: Record<string, T>): T[] {
	const items = getValueAsArray(value)

	return items?.length > 0
		? items.map((value) => {
				if (choices?.[value]) {
					return choices?.[value]
				} else if (value === null || value === undefined) {
					return { label: value, value } as T
				} else {
					return { label: value, value } as T
				}
			})
		: items
}
